import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { SPACE_CONTEXTS_COLUMN_ID } from "../constants";
import { SpaceDetailsContext } from "../types";
import SpaceDetailsContextsDescriptionCell from "./DescriptionCell";
import SpaceDetailsContextsInheritedFromCell from "./InheritedFromCell";
import SpaceDetailsContextsNameCell from "./NameCell";

const SPACE_CONTEXTS_CELLS: TableCellPerColumn<SpaceDetailsContext> = {
  [SPACE_CONTEXTS_COLUMN_ID.NAME]: SpaceDetailsContextsNameCell,
  [SPACE_CONTEXTS_COLUMN_ID.DESCRIPTION]: SpaceDetailsContextsDescriptionCell,
  [SPACE_CONTEXTS_COLUMN_ID.INHERITED_FROM]: SpaceDetailsContextsInheritedFromCell,
};

export default SPACE_CONTEXTS_CELLS;
